import styled, { css } from "styled-components";

import { Button, Container } from "components";

import { media } from "constants/media";

export const Wrapper = styled.div`
    background: var(--color-grey-45);
    padding: 24px 0;

    ${media.mdUp} {
        padding: 48px 0;
    }
`;

export const StyledContainer = styled(Container)`
    display: block;

    ${media.mdUp} {
        display: flex;
    }
`;

export const Left = styled.div`
    width: 100%;

    ${media.mdUp} {
        margin-right: 48px;
        min-width: 264px;
        width: 264px;
    }
`;

export const LeftContent = styled.div`
    button {
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
        width: 100%;
    }

    ${media.mdUp} {
        background: var(--color-white);
        border-radius: 24px;
        padding: 24px;
    }
`;

export const Right = styled.div`
    width: 100%;
`;

export const RightTitle = styled.h2`
    font-size: 32px;
    font-weight: bold;
    line-height: 48px;
    margin-bottom: 8px;

    ${media.mdUp} {
        font-size: 40px;
        line-height: 64px;
    }
`;

export const RightDescription = styled.p`
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 16px;

    ${media.mdUp} {
        font-size: 15px;
    }
`;

export const Cards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledButton = styled(Button)`
    justify-content: center;
    margin-top: 24px;
    width: 100%;
`;

export const Radio = styled.input`
    accent-color: var(--color-primary);
    height: 18px;
    width: 18px;

    &:checked {
        background-color: var(--color-primary);
    }
`;

export const Checkbox = styled.input`
    color: var(--color-white);
    height: 18px;
    width: 18px;

    &:checked {
        accent-color: var(--color-primary);
    }
`;

export const DesktopOnly = styled.div`
    display: none;

    ${media.mdUp} {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;
export const MobileOnly = styled.div`
    ${media.mdUp} {
        display: none;
    }
`;

export const MobileContent = styled.div<{ visible: boolean }>`
    background: var(--color-white);
    color: var(--color-black);
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    padding: 24px 24px 100px;
    position: fixed;
    right: -100%;
    row-gap: 16px;
    top: 0;
    transition: all 250ms ease-in-out;
    width: 100%;
    z-index: 100;

    /*stylelint-disable-next-line*/
    ${({ visible }) =>
        visible &&
        css`
            right: 0;
            transition: all 250ms ease-in-out;
        `}
`;
